import React from 'react'
import styled from 'styled-components'
import UnavailableIcon from '../asserts/icon/unavailable.svg'

const OverlayWrapperStyled = styled.div`
  position: absolute;
  top: 0; 
  left: 0; 
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #F3F5F7BF;
  justify-content: center;
  align-items: flex-start;

  .content {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);

    img {
      height: 40px;
      margin-right: 10px;
      margin-bottom: 20px;
    }

    h1 {
      color: #4C6088;
      font-weight: 600;
    }  
  }
`

const OverlayWrapper = ({trends}) => {

  return (
    <OverlayWrapperStyled>
      <div className="content">
        <img src={UnavailableIcon} alt="Unavailable" />
        <h1>Unavailable with current membership</h1>
      </div>
    </OverlayWrapperStyled>
  )
}

export default OverlayWrapper
